import { useMemo } from 'react';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { WorkflowConfiguration } from 'models/WorkflowConfiguration';
import { doesValueExist } from 'utils';

type UseSpecificRulesProps = Partial<
  Pick<
    WorkflowConfiguration,
    'automaticallySendNDA' | 'automaticallySendNDAEnabled'
  >
>;

export default function useSpecificRules(config: UseSpecificRulesProps) {
  const { automaticallySendNDA, automaticallySendNDAEnabled } = config;

  return useMemo<RadioOption<string>[]>(
    () => [
      ...(doesValueExist(automaticallySendNDA)
        ? [
            {
              label: 'automaticallySendNDA',
              value: 'automaticallySendNDA',
              enabled: automaticallySendNDAEnabled,
            },
          ]
        : []),
    ],
    [automaticallySendNDA, automaticallySendNDAEnabled],
  );
}
